import { Icon, Layout, Menu } from 'antd'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { NavLink, useRouteMatch } from 'react-router-dom'

import '../../styles/UploadStickerNav.css'
type LinkInfo = {
  pathname: string
  id: string
  icon: string
}
export default function SideNavUi({
  linkInfoList,
}: {
  linkInfoList: LinkInfo[]
}) {
  return (
    <Layout.Sider theme="light" width="215" className="upload-nav-sider">
      <Menu
        mode="inline"
        // selectedKeys={linkInfoList.map((linkInfo) => linkInfo.pathname)}
        style={{ height: '100%', paddingTop: 44 }}
        defaultSelectedKeys={linkInfoList[0].pathname as any}
      >
        {linkInfoList.map(({ pathname, id, icon }) => (
          <Menu.Item key={pathname}>
            <NavLink
              to={`${pathname}`}
              className="upload-nav"
              activeClassName="upload-nav-active"
            >
              <div className="upload-nav-box">
                {React.isValidElement(icon) ? (
                  icon
                ) : (
                  <Icon type={icon} style={{ fontSize: 18 }} />
                )}
                <FormattedMessage id={id} />
              </div>
            </NavLink>
          </Menu.Item>
        ))}
      </Menu>
    </Layout.Sider>
  )
}
